export const AccountTabBox = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="42" height="28" viewBox="0 0 42 28">
		<g id="info_icon" transform="translate(-0.256 -3)">
			<g id="card" transform="translate(0.256 3)" fill="none" stroke="inherent" stroke-width="3">
				<rect width="42" height="28" rx="4" stroke="none" />
				<rect x="1.5" y="1.5" width="39" height="25" rx="2.5" fill="none" />
			</g>
			<g id="lineas" transform="translate(22.847 14.402)">
				<line
					id="Línea_1"
					data-name="Línea 1"
					x2="11.696"
					transform="translate(0 0)"
					fill="none"
					stroke="inherent"
					stroke-linecap="round"
					stroke-width="3"
				/>
				<line
					id="Línea_2"
					data-name="Línea 2"
					x2="8.143"
					transform="translate(0.199 5.546)"
					fill="none"
					stroke="inherent"
					stroke-linecap="round"
					stroke-width="3"
				/>
			</g>
			<path
				id="person_outline"
				d="M133.266,133.974c1.922,0,5.766.978,5.766,2.9v2.158H127.5v-2.158C127.5,134.952,131.344,133.974,133.266,133.974Zm0-6.474a2.893,2.893,0,0,1,2.866,2.9,2.866,2.866,0,0,1-5.732,0A2.893,2.893,0,0,1,133.266,127.5Zm0,7.856c-2.124,0-4.383,1.045-4.383,1.517v.776h8.767v-.776C137.649,136.4,135.39,135.356,133.266,135.356Zm0-6.474a1.511,1.511,0,0,0-1.517,1.517,1.518,1.518,0,0,0,3.035,0A1.511,1.511,0,0,0,133.266,128.882Z"
				transform="translate(-120.122 -116.451)"
				fill="inherent"
			/>
		</g>
	</svg>
);
